module.exports = __webpack_public_path__ + "static/media/RP-26.c28031f9.pdf";